import { render, staticRenderFns } from "./AppTabbar.vue?vue&type=template&id=48e6c59b"
import script from "./AppTabbar.vue?vue&type=script&lang=js"
export * from "./AppTabbar.vue?vue&type=script&lang=js"
import style0 from "./AppTabbar.vue?vue&type=style&index=0&id=48e6c59b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports